import './index.scss'
import RouterConfig from './router/router.config'

const DEFAULT_OPTIONS = {
  /**
   * 在路由之后去 隐藏loading
  */
  noAfterRouteIsLoading: []
}

const install = (Vue, { router, options = DEFAULT_OPTIONS }) => {
  if (install.installed) {
    return
  }

  install.installed = true

  if (!router) {
    console.error('@rrc-materials/layout need options: router') // eslint-disable-line
    return
  }

  RouterConfig(router, options)
}

export default {
  install
}
